import { render, staticRenderFns } from "./BlockListCustomCtaBoxesCustom.vue?vue&type=template&id=1071ee8e"
import script from "./BlockListCustomCtaBoxesCustom.vue?vue&type=script&lang=js"
export * from "./BlockListCustomCtaBoxesCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports